import React from 'react'
import { usePortal } from '../hooks/usePortal'
import Breadcrumbs from '../components/Breadcrumbs'
import { createPortal } from 'react-dom'
import { ReactSVG } from 'react-svg'
import Btn from '../components/Btn'
import { useAxios } from '../hooks/useAxios'
import { getLevels } from '../api/getLevels'
import { getPrizes } from '../api/getPrizes'
import { toast } from 'react-toastify'
import Card from '../components/Card'
import Skeleton from 'react-loading-skeleton'
import { UserStore } from '../store/userStore'
import classNames from 'classnames'
import PrizeCard from '../components/PrizeCard'

const RewardsPage: React.FC<any> = () => {
  const BREADCRUMBS = [
    {
      label: 'Главная',
      path: '/'
    },
    {
      label: 'Награды',
      path: '/rewards'
    }
  ]
  const {
    response: levels,
    loading: levelsLoading,
    fire: levelsFire
  } = useAxios()
  const {
    response: prizes,
    loading: prizesLoading,
    fire: prizesFire
  } = useAxios()
  const [levelsExpanded, setLevelsExpanded] = React.useState(false)
  const levelsItems = React.useMemo(() => {
    if (levelsExpanded) return levels?.data?.items ?? []

    return (levels?.data?.items ?? []).slice(0, 9)
  }, [levels, levelsExpanded])

  React.useEffect(() => {
    Promise.all([levelsFire(getLevels()), prizesFire(getPrizes(6))]).catch(
      (e: any) => {
        toast.error(e.message)
      }
    )
  }, [])

  const { portal } = usePortal()

  return (
    <div className={'page'}>
      <Breadcrumbs className={'page__breadcrumbs'} breadcrumbs={BREADCRUMBS} />
      {portal &&
        createPortal(
          <Breadcrumbs breadcrumbs={BREADCRUMBS}></Breadcrumbs>,
          portal
        )}

      <header className="page__head">
        <h1>Награды</h1>
      </header>

      <div className="page__content">
        {levelsItems.length || levelsLoading ? (
          <section
            className={classNames('app-section', {
              'mb-md-14 mb-sm-12': prizes?.data?.length || prizesLoading
            })}
          >
            <div className={'app-section__content'}>
              {/*<RewardsBlock rewards={rewards} />*/}
              <Card>
                {levelsLoading ? (
                  <header className={'card-head d-block'}>
                    <Skeleton height={'2rem'} width={'24rem'}></Skeleton>
                  </header>
                ) : (
                  <header
                    className={
                      'card-head u-md-flexAlignItemsCenter u-sm-flexCol'
                    }
                  >
                    <h2 className={'text-h3'}>{levels?.data?.current}</h2>
                    <p className={'text-body-small text-secondary-color'}>
                      Баллы:{' '}
                      {UserStore.data.balls
                        ?.toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                    </p>
                  </header>
                )}
                <div className={'card-content app-grid _columns-3-1 '}>
                  {levelsLoading ? (
                    <>
                      {Array.from({ length: 9 }).map((_, i) => (
                        <div key={i} className={'u-flexGrow1'}>
                          <Skeleton
                            height={'8rem'}
                            borderRadius={'3.2rem'}
                          ></Skeleton>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      {levelsItems.map((item: any) => (
                        <div
                          key={item.id}
                          className={`reward-card ${
                            item.complete ? '_received' : '_blocked'
                          }`}
                        >
                          <div className={'reward-card__img'}>
                            {item.pictureUrl && (
                              <img src={item.pictureUrl} alt={item.name} />
                            )}
                          </div>

                          <div className={'reward-card__content'}>
                            <h3 className={'reward-card__name text-h4'}>
                              {item.name}
                            </h3>

                            <div className={'reward-card__points'}>
                              {item.complete ? (
                                <ReactSVG
                                  src={'/i/svg/check.svg'}
                                  className={'svg-icon'}
                                ></ReactSVG>
                              ) : (
                                <>
                                  <ReactSVG
                                    src={'/i/svg/rating.svg'}
                                    className={'svg-icon'}
                                  ></ReactSVG>
                                  <span>{item.cost}</span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
                {levels?.data?.items?.length > 9 && !levelsExpanded ? (
                  <footer className={'card-foot u-flex u-flexJustifyCenter'}>
                    <Btn
                      text
                      small
                      type={'button'}
                      onClick={() => setLevelsExpanded(true)}
                    >
                      <span>Показать все</span>
                      <ReactSVG
                        wrapper={'span'}
                        src={'/i/svg/plus.svg'}
                      ></ReactSVG>
                    </Btn>
                  </footer>
                ) : null}
              </Card>
            </div>
          </section>
        ) : null}

        {prizes?.data?.length || prizesLoading ? (
          <section className={'app-section'}>
            {prizesLoading ? (
              <header className={'app-section__head d-block'}>
                <Skeleton height={'4rem'} width={'24rem'}></Skeleton>
              </header>
            ) : (
              <div className={'app-section__head'}>
                <h2>Витрина призов</h2>

                <Btn to={'/rewards/prizes'} text small>
                  <span>Все призы</span>
                  <ReactSVG
                    wrapper={'span'}
                    src={'/i/svg/arrow-right.svg'}
                  ></ReactSVG>
                </Btn>
              </div>
            )}

            <div className={'app-section__content prizes _preview'}>
              {prizesLoading ? (
                <>
                  {Array.from({ length: 6 }).map((_, i) => (
                    <div key={i}>
                      <Skeleton
                        height={'32rem'}
                        borderRadius={'3.2rem'}
                      ></Skeleton>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {prizes?.data?.map((prize: any) => (
                    <PrizeCard {...prize} key={prize.id}></PrizeCard>
                  ))}
                </>
              )}
            </div>
          </section>
        ) : null}
      </div>
    </div>
  )
}

export default RewardsPage
